import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["nav", "panel"]

  connect() {
    const hash = window.location.hash.replace("#", "")
    if (hash) {
      const btn = this.navTarget.querySelector(`[data-tab="${hash}"]`)
      if (btn) {
        this.activate(btn, hash)
      }
    }
  }

  select(event) {
    this.activate(event.currentTarget, event.currentTarget.dataset.tab)
  }

  activate(btn, tab) {
    this.navTarget.querySelectorAll("[data-tab]").forEach(b => {
      b.classList.remove("text-emerald-600", "border-emerald-600", "dark:text-emerald-400", "dark:border-emerald-400")
      b.classList.add("text-gray-500", "border-transparent", "hover:text-gray-700", "dark:text-gray-400", "dark:hover:text-gray-300")
    })
    btn.classList.remove("text-gray-500", "border-transparent", "hover:text-gray-700", "dark:text-gray-400", "dark:hover:text-gray-300")
    btn.classList.add("text-emerald-600", "border-emerald-600", "dark:text-emerald-400", "dark:border-emerald-400")

    this.panelTargets.forEach(p => {
      p.classList.toggle("hidden", p.dataset.tab !== tab)
    })

    history.replaceState(null, "", `#${tab}`)
  }
}
